module.exports = __webpack_public_path__ + "static/get-wines-00-hero-4f556d7936d40eb081808fa8ed138f38.jpg";